function initDeliveryCountdown() {
  const widgets = document.querySelectorAll(".delivery-countdown");

  widgets.forEach(function (widget) {
    if (widget.dataset.initialized === "true") return;
    widget.dataset.initialized = "true";

    const cutoffValue = widget.dataset.cutoff || "12:00";
    const cutoffParts = cutoffValue.split(":");

    const cutoffHour = parseInt(cutoffParts[0], 10) || 12;
    const cutoffMinute = parseInt(cutoffParts[1], 10) || 0;

    const timer = widget.querySelector(".deliveryTimer");
    const delivery = widget.querySelector(".deliveryDay");

    if (!timer || !delivery) return;

    function updateCountdown() {
      const now = new Date();
      const day = now.getDay();

      const cutoffTime = new Date();
      cutoffTime.setHours(cutoffHour, cutoffMinute, 0, 0);

      let deliveryDate = new Date();

      if (day >= 1 && day <= 3) {
        deliveryDate.setDate(now.getDate() + (now < cutoffTime ? 1 : 2));
      } else if (day === 4) {
        deliveryDate.setDate(now.getDate() + (now < cutoffTime ? 1 : 5));
      } else {
        const daysUntilTuesday = ((2 - day) + 7) % 7 || 7;
        deliveryDate.setDate(now.getDate() + daysUntilTuesday);
      }

      delivery.textContent = deliveryDate.toLocaleDateString("en-IE", {
        weekday: "long"
      });

      let diff = cutoffTime - now;

      if (diff < 0) {
        cutoffTime.setDate(cutoffTime.getDate() + 1);
        diff = cutoffTime - now;
      }

      const hrs = Math.floor(diff / 1000 / 60 / 60);
      const mins = Math.floor(diff / 1000 / 60) % 60;

      timer.textContent =
        String(hrs).padStart(2, "0") +
        " hrs " +
        String(mins).padStart(2, "0") +
        " mins";
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
}

document.addEventListener("DOMContentLoaded", initDeliveryCountdown);
document.addEventListener("shopify:section:load", initDeliveryCountdown);
document.addEventListener("shopify:block:select", initDeliveryCountdown);
initDeliveryCountdown();